import React, { ReactNode } from 'react';
import { Accordion } from 'react-bootstrap';
import './SFCAccordion.css';

interface SFCAccordionProps {
  children: ReactNode;
  defaultActiveKey?: string | string[];
  activeKey?: string | null;
  onSelect?: (eventKey: string | null) => void;
  className?: string;
}

export const SFCAccordion: React.FC<SFCAccordionProps> = ({
  children,
  defaultActiveKey,
  activeKey,
  onSelect,
  className
}) => {
  const accordionClassName = ['sfc-accordion', className].filter(Boolean).join(' ');
  // If activeKey is provided, use controlled behavior
  if (activeKey !== undefined && onSelect !== undefined) {
    return (
      <Accordion
        activeKey={activeKey}
        onSelect={(eventKey) => onSelect(eventKey as string | null)}
        className={accordionClassName}
      >
        {children}
      </Accordion>
    );
  }

  // Otherwise, use uncontrolled behavior (default)
  return (
    <Accordion
      defaultActiveKey={defaultActiveKey ?? '0'}
      alwaysOpen
      className={accordionClassName}
    >
      {children}
    </Accordion>
  );
};
